document.addEventListener('DOMContentLoaded', function () {
    const selects = document.querySelectorAll('.has-report select');
    if (!selects.length) return;

    selects.forEach(function (select) {
        select.addEventListener('change', function () {
            const value = this.value.toLowerCase();
            if (value.includes('report') && value.includes('death')) {
                window.open('/insurance/beneficiary-resources/report-death-of-member/', '_blank');
            }
        });
    });
});